import RichText from '@rsa-digital/evo-shared-components/components/RichText';
import spacing from '@rsa-digital/evo-shared-components/helpers/spacing';
import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const StyledRichText = styled(RichText)`
  margin-top: ${spacing(3)};

  a[href^='mailto:'] {
    word-break: break-all;
  }
`;
